'use strict';

function ContributingFBGsGridDirective() {
  return {
    restrict: 'E',
    controller: 'ContributingFBGsGridController',
    template: require('../templates/contributing-fbgs-grid.html'),
    scope: {
      brushFilters: '<',
      brushFilterChanged: '='
    },
    link: function link(scope) {
      scope.$on('grid:contributing-fbgs:reload-data', function () {
        scope.refreshData();
      });
      scope.$on('grid:rowSelectionChanged', function (event, selectedRows) {
        var filter = scope.gridRowSelected(selectedRows);
        scope.brushFilterChanged(filter);
      });
    }
  };
}
ContributingFBGsGridDirective.$inject = [];
module.exports = ContributingFBGsGridDirective;